import { useState } from 'react';
import CustomModal from './CustomModal';
import { useAuth } from 'react-oidc-context';
import { createManifest } from '../service/createManifest';
import showToast from './ToastComponent';

export function CreateShipmentButton() {
  const [showModal, setShowModal] = useState(false);
  const { user } = useAuth();

  const closeModal = () => setShowModal(false);
  const openModal = () => setShowModal(true);

  const handleCreateShipment = async () => {
    if (!user?.access_token) {
      console.log('Access token not found');
      return;
    }

    const result = await createManifest(user.access_token);

    if (result.status === 201) {
      showToast({ type: 'success', message: 'Manifest created successfully' });
      closeModal();
    } else {
      console.log(result);
      showToast({ type: 'error', message: result.data });
    }
  };

  return (
    <>
      <button
        className={`ml-4 text-xs border border-secondary-pink-600 rounded font-semibold text-secondary-pink-600 
bg-white px-3 py-2 hover:bg-secondary-pink-600 hover:text-white`}
        onClick={() => openModal()}
      >
        Create Manifest
      </button>
      <CustomModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        header="Confirmation"
        footer={
          <>
            <button
              className="mr-4 bg-primary-blue-500 text-white px-4 py-2 w-24 rounded"
              onClick={() => handleCreateShipment()}
            >
              Yes
            </button>
            <button
              className="bg-white border border-solid border-primary-blue-500 text-primary-blue-500 w-24 px-4 py-2 rounded"
              onClick={() => closeModal()}
            >
              Cancel
            </button>
          </>
        }
      >
        <p>Do you really want to create the manifest ?</p>
      </CustomModal>
    </>
  );
}
